<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

const handleError = () => clearError({ redirect: '/' })

const router = useRouter()

const handleGoBack = () => {
  clearError()
  router.back()
}
</script>

<template>
  <div
    class="flex min-h-[100dvh] flex-col items-center justify-center bg-gray-100 px-4 py-12 dark:bg-gray-800"
  >
    <div class="mx-auto max-w-md text-center">
      <h1 class="text-9xl font-bold text-gray-900 dark:text-gray-50">
        {{ error?.statusCode }}
      </h1>
      <h2 class="mt-6 text-2xl font-semibold text-gray-700 dark:text-gray-300">
        {{ error?.message || 'エラーが発生しました' }}
      </h2>
      <!-- <p class="mt-4 text-gray-500 dark:text-gray-400">
        テキストテキストテキストテキスト
      </p> -->
      <div class="flex gap-4 justify-center">
        <button
          @click="handleGoBack"
          class="mt-6 inline-flex h-10 items-center justify-center rounded-md bg-gray-900 px-6 text-sm font-medium text-gray-50 shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300"
        >
          一つ前に戻る
        </button>
        <button
          @click="handleError"
          class="mt-6 inline-flex h-10 items-center justify-center rounded-md bg-gray-900 px-6 text-sm font-medium text-gray-50 shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300"
        >
          トップに戻る
        </button>
      </div>
    </div>
  </div>
</template>
